export default __webpack_public_path__ + "static/media/polka-social.72df8f04.png";